// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2laj3","row":"styles_row__PSTs0"};